import { render, staticRenderFns } from "./SystemMessage.vue?vue&type=template&id=2a7846c2&scoped=true&"
import script from "./SystemMessage.vue?vue&type=script&lang=js&"
export * from "./SystemMessage.vue?vue&type=script&lang=js&"
import style0 from "./SystemMessage.vue?vue&type=style&index=0&id=2a7846c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7846c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a7846c2')) {
      api.createRecord('2a7846c2', component.options)
    } else {
      api.reload('2a7846c2', component.options)
    }
    module.hot.accept("./SystemMessage.vue?vue&type=template&id=2a7846c2&scoped=true&", function () {
      api.rerender('2a7846c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/system-messages/SystemMessage.vue"
export default component.exports